class GetProductRequest {
  constructor(public readonly page: number,
              public readonly perPage: number,
              public readonly hashtagIds: Array<number>,
              public readonly sortBy: string) {
  }
}

export default GetProductRequest;